import { render } from "./ProgressRing.vue?vue&type=template&id=060ade06&scoped=true"
import script from "./ProgressRing.vue?vue&type=script&lang=js"
export * from "./ProgressRing.vue?vue&type=script&lang=js"

import "./ProgressRing.vue?vue&type=style&index=0&id=060ade06&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060ade06"]])

export default __exports__